<template>
    <div v-if="content" class="blog-post">
        <div class="post-wrapper shadow">
            <div class="post-header black p-5 d-flex align-items-end">
                <div class="overlay" :style="{backgroundImage: 'url(' + content.img + ')'}"></div>

                <div class="post-meta">
                    <b-row>
                        <b-col cols="9">
                            <h1 class="display-4">{{ content.title }}</h1>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="12">Paru le {{ content.date }}</b-col>

                        <b-col cols="12" md="12" class="text-blue">Sujet(s): 
                            <div class="d-inline" v-for="(tag, index) in content.tags" :key="'tag-' + index">
                                <b><b-link class="text-blue" @click.prevent="$emit('setTag', tag)">{{ tag }}</b-link></b>
                                <span v-if="index < content.tags.length - 1">, </span>                                
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <div class="post-body px-5 py-4" :class="previewOnly">
                <div class="mb-5" v-html="body"></div>

                <div>
                    <b-button v-if="current.cta" block :to="current.cta.link" class="ebook-cta upper shadow p-3">
                        {{ current.cta.text }}
                    </b-button>

                    <b-button v-else block @click="sendMessage(2)" class="ebook-cta upper shadow p-3">
                        Contactez un spécialiste dès aujourd'hui pour planifier une rencontre exploratoire
                    </b-button>
                </div>
            </div>

            <div v-if="preview" class="preview-expender text-center pt-5">
                <b-link href="#" @click.prevent="expandPreview()">
                    <font-awesome-icon class="text-blue" icon="chevron-down" size="3x" v-b-tooltip.hover title="Voir tout l'article"/>
                </b-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: [
      'current'
  ],
  data() {
    return {
        preview: false
    }
  },
  computed: {
    previewOnly() {
        if (this.preview === true) {
            return `preview`
        }
        return ``
    },
    content() {
        return this.current.content
    },
    body() {
        if (this.current.content && this.current.content.content) {
            let div = document.createElement("div")
            let arr = this.current.content.content

            for (let i in arr) {
                let block = document.createElement(arr[i].type)
                block.innerHTML = arr[i].text
                if (arr[i].type.includes('h')) block.classList.add("text-blue")
                div.appendChild(block)
            }

            return div.innerHTML
        } else {
            return false
        }
    }
  },
  mounted() {
    this.setPreview()
  },
  methods: {
    setPreview() {
        let selected = this.$route.params.title 

        if (selected && selected === 'recent') {
            this.preview = true
        }
        else {
            this.preview = false
        }
        return false
    },
    expandPreview() {
        this.preview = false
        return false
    },
    sendMessage(subject) {
      this.$emit('sendMessage', subject)
    }
  }
}
</script>

<style scoped>
.posts {
    max-height: 150vh;
    overflow-y: auto;
}

.post-meta {
  z-index: 10;
}

.post-body {
    transition: all 0.5s ease;
    z-index: 10;
}

.post-body.preview {
    max-height: 25vh;
    overflow-y: hidden;
}

.post-wrapper {
    position: relative;
}

.preview-expender {
    position: absolute;
    z-index: 100;
    bottom: 0;
    width: 100%;
    background: rgba(255,255,255,0);
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,255,255,0)), color-stop(0%, rgba(255,255,255,0)), color-stop(30%, rgba(255,255,255,1)), color-stop(100%, rgba(255,255,255,1)));
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: -o-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=0 );
}

.post-header {
    position: relative;
    border-radius: 0;
    color: #fff;
    min-height: 35vh;
}

.post-header > .content,
.post-header > h1,
.post-header > .lead,
.post-header > .btn-cta {
    position: relative;
    left: 0;
    z-index: 100;
}

.post-header > .content,
.post-header > h1,
.post-header > .lead {
    margin: 0 2rem;
}

.post-header > .overlay {
    position: absolute;
    opacity: 0.3;
    top: 0;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
}

.post {
    background-color: #000;
}

.sticky-top {
  top: 15vh;
}
</style>
